import { hashEmail } from './hashEmail';

export const hashIfEmail = (input: string) => (/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/.test(input) ? hashEmail(input) : input);
